import { createContext, useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { get } from "../adapters/xhr/api";

const TaxAppealContext = createContext({});

export const TaxAppealProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const initialValue = {
    editMode: false,
    disableAfterPayment: false,
    disableAfterPaymentDifferentPeriod: false,
    disableAfterPaymentSameBuilding: false,
    id: null,
    linked_id: null,
    appeal_request_id: null,
    user: null,
    submitter_type_id: null,
    other_submitter_type_text: null,
    legal_representative_attachment: null,
    property_address: null,
    activity_address: null,

    unit_owner_type_id: null,
    unit_owner_first_name: null,
    unit_owner_rest_name: null,
    unit_owner_nationality_id: null,
    unit_owner_national_id: null,
    unit_owner_national_id_attachment: null,
    unit_owner_passport_no: null,
    unit_owner_passport_no_attachment: null,
    unit_owner_name: null,
    commercial_registration_number: null,
    commercial_registration_number_attachment: null,
    tax_number: null,
    tax_number_attachment: null,
    unit_owner_other: null,
    unit_owner_other_attachment: null,

    appeal_type_id: null,
    appeal_rental_value: null,
    appeal_tax_value: null,
    appealed_tax_period_type_id: null,
    appeal_reasons: null,
    appeal_reason_type_id: null,
    other_appeal_reason_type_text: null,
    unit_code: null,
    governorate_text: null,
    district_text: null,
    village_text: null,
    street_text: null,
    build_text: null,
    floor_text: null,
    unit_text: null,

    unit_address_type_id: null,
    governorate_id: null,
    district_id: null,
    village_id: null,
    other_village_text: null,
    region_id: null,
    other_region_text: null,
    real_estate_id: null,
    other_real_estate_text: null,
    floor_id: null,
    unit_id: null,
    other_unit_text: null,

    unit_type_id: null,
    facility_unit_type_id: null,

    has_additional_attachments: null,

    acknowledge_not_submitted_same_data_before: null,
    acknowledge_all_documents_are_correct: null,
    acknowledge_unwillingness_submit_via_digital: null,
    additional_attachments: [],

    submitter_type_text: null,
    unit_owner_type_text: null,
    unit_owner_nationality_text: null,
    appeal_type_text: null,
    appealed_tax_period_type_text: null,
    appeal_reason_type_text: null,
    unit_address_type_text: null,
    other_unit_text: null,
    unit_type_text: null,
    facility_unit_type_text: null,
    egypt_nationality_id: null,

    form_number: null,
    request_number: null,
    temp_number: null,
    status: null,
  };

  const [appealRequest, setAppealRequest] = useState(initialValue);
  const [user, setUser] = useState({
    first_name: "",
    father_name: "",
    grandfather_name: "",
    family_name: "",
    email: "",
    phone_number: "",
    nationality: { key: "", value: "" },
    national_id: "",
    passport_number: "",
    building_number: "",
    governorate_id: "",
    district_id: "",
    village_id: "",
    street_id: "",
    street_other: "",
    national_id_file: {},
    passport_number_file: {},
    profile: {},
  });

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified = response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      !location.pathname.includes("/tax-appeal/temporary") &&
      !location.pathname.includes("/tax-appeal/details") &&
      !location.pathname.includes("/tax-appeal/add") &&
      !location.pathname.includes("/tax-appeal/payment")
    ) {
      resetAppealRequest();
    }
  }, [location]);

  const updateAppealRequest = (field, val) => {
    setAppealRequest({
      ...appealRequest,
      [field]: val,
    });
  };

  const resetAppealRequest = () => {
    setAppealRequest(initialValue);
  };

  return (
    <TaxAppealContext.Provider
      value={{
        appealRequest,
        updateAppealRequest,
        setAppealRequest,
        user,
        setUser,
        resetAppealRequest,
      }}
    >
      <Outlet />
    </TaxAppealContext.Provider>
  );
};

export default TaxAppealContext;
